/* eslint-disable */
import React, { createContext, useState, useEffect, useContext } from "react";
import Web3Context from "./Web3Context";
import { address, useContract, useBUSD } from "../hooks/useContracts.js";
import { BigNumber, constants, ethers, utils } from "ethers";
import { useToasts } from "react-toast-notifications";
import refHandle from "../hooks/utils";
const TonkenContext = createContext();

const TokenProvider = ({ children }) => {
  const { addToast } = useToasts();
  const {
    accounts,
    isLoaded,
    setupdate,
    update,
    etherJSProvider,
    errorMessage,
  } = useContext(Web3Context);
  const [id, setid] = useState(0);
  const [update_, setupdate_] = useState(0);
  const [userData, setuserData] = useState({
    totalWithdrawn_: 0,
    totalDeposits_: 0,
    totalBonus_: 0,
    totalreinvest_: 0,
    hold_: 0,
    balance_: 0,
    referrerAmount: 0,
    nextAssignment_: 0,
    amountOfDeposits: 0,
    checkpoint: 0,
    isUser_: false,
    referrer_: "",
    deltaWithdrawDate: 0,
    referrerCount_: [0, 0, 0,0,0],
    referrerBonus: [0, 0, 0],
  });
  const [allData, setallData] = useState({
    totalUsers_: 0,
    totalInvested_: 0,
    totalReinvested_: 0,
    totalWithdrawn_: 0,
    totalDeposits_: 0,
    balance_: 0,
    roiBase: 0,
    bonusPool: 0,
    comunityBonus: 0,
    currentRoi: 0,
    maxProfit: 0,
    minDeposit: 0,
    daysFormdeploy: 0,
  });
  const [deposit, setdeposit] = useState(0);
  const [balanceOf, setbalanceOf_] = useState(0);
  const [isApprove, setisApprove] = useState(false);

  const [userPlans, setuserPlans] = useState([
    {
      plan: 0,
      percent: 0,
      amount: 0,
      start: 0,
      finish: 0,
    },
  ]);
  const [solPrice, setSolPrice] = useState(1);

  const fANTOM = useContract();
  const Token = useBUSD();

  useEffect(() => {
    fetch("https://api.coingecko.com/api/v3/coins/binancecoin")
      .then((res) => res.json())
      .then((res) => {
        // console.log(res.tickers[0].last.toFixed(2),"priocesss");
        setSolPrice(res.tickers[0].last.toFixed(2));
      });
  }, []);

  useEffect(() => {
    if (!isLoaded) return;
    // getPublicData();
    getUserData();
    // getUserDataDepositlenght()
    allowanceHandle();
    return () => {};
  }, [accounts, isLoaded, update_]);

  const updateHandle = () => {
    setupdate_(update_ + 1);
  };
  const idHandle = (id_) => {
    setid(id_);
  };

  const balanceOfHandle = async () => {
    if (
      !isLoaded &&
      accounts != "000000000000000000000000000000000000000000000"
    )
      return;
    const [load, contract] = await Token;
    let balance_ = await contract.balanceOf(accounts);
    balance_ = Number(ethers.utils.formatEther(balance_)).toFixed(3);
    setbalanceOf_(balance_);
  };

  const approveHandle = async (type) => {
    if (
      !isLoaded &&
      accounts != "000000000000000000000000000000000000000000000"
    )
      return;
    const [load, contract] = await Token;
    const addr = address.fantom;
    const res = await contract.approve(addr, constants.MaxUint256);
    res.wait().then(() => updateHandle());
  };

  const allowanceHandle = async () => {
    if (
      !isLoaded &&
      accounts != "000000000000000000000000000000000000000000000"
    )
      return;
    const [load, contract] = await Token;
    const allowance_ = await contract.allowance(accounts, address.fantom);
    // console.log(allowance_,"allowance_");
    setisApprove(allowance_.gt(constants.MaxUint256.div(5)));
  };

  const invest = async (investAmt,plan) => {
    if (!isLoaded) {
      errorMessage();
      return;
    } 
    


    
    const ref_ = refHandle();
    try {
      const [load, contract] = await fANTOM;
      investAmt = utils.parseEther(investAmt.toString());      
      const res = await contract.deposit(plan,ref_,investAmt);
      addToast("Invest success", { appearance: "success" });
      res.wait().then((value) => {
        updateHandle();
      });
    } catch (err) {
      if (err.data != undefined)
        addToast(err.data.message, { appearance: "error" });
      else addToast(err.message, { appearance: "error" });
    }
  };

  const withdraw = async () => {
    if (!isLoaded) {
      errorMessage();
      return;
    }
    const [load, contract] = await fANTOM;

    try {
      const res = await contract.withdraw();
      addToast("withdraw success", { appearance: "success" });
      res.wait().then((value) => {
        updateHandle();
      });
    } catch (err) {
      if (err.data != undefined)
        addToast(err.data.message, { appearance: "error" });
      else addToast(err.message, { appearance: "error" });
    }
  };

  const reinvestment = async () => {
    if (!isLoaded) {
      errorMessage();
      return;
    }
    try {
      const [load, contract] = await fANTOM;
      const res = await contract.reinvestment();
      addToast("reinvestment success", { appearance: "success" });
      res.wait().then((value) => {
        updateHandle();
      });
    } catch (err) {
      if (err.data != undefined)
        addToast(err.data.message, { appearance: "error" });
      else addToast(err.message, { appearance: "error" });
    }
  };

  const getUserDataDepositlenght = async () => {
    if (
      !isLoaded &&
      accounts != "000000000000000000000000000000000000000000000"
    )
      return;
    const [load, contract] = await fANTOM;

    const data = await contract.getUserAmountOfDeposits(accounts);

    const length = data.toNumber();
    // console.log(data.toNumber(),accounts);
    if (length == 0) return;
    setdeposit(length);

    let plans_ = [];

    for (let index = 0; index < length; index++) {
      const { plan, percent, amount, start, finish } =
        await contract.getUserDepositInfo(accounts, index);
      // console.log(amount,"lenghtlenght");
      plans_.push({
        plan,
        percent: percent.toNumber(),
        amount: utils.formatEther(amount),
        start: start.toNumber(),
        finish: finish.toNumber(),
        wallet: accounts,
      });
    }

    setuserPlans(plans_);
  };

  const getUserDataDeposit = async (id) => {
    if (
      !isLoaded &&
      accounts != "000000000000000000000000000000000000000000000"
    )
      return;
    const [load, contract] = await fANTOM;
    const { plan, percent, amount, start, finish } =
      await contract.getUserDepositInfo(accounts, id);
    let plans_ = [];
    plans_.push({
      plan,
      percent: percent.toNumber(),
      amount: utils.formatEther(amount),
      start: start.toNumber(),
      finish: finish.toNumber(),
      wallet: accounts,
    });
    setuserPlans(plans_);
  };
  const getUserData = async () => {
    if (
      !isLoaded &&
      accounts != "000000000000000000000000000000000000000000000"
    )
      return;
    const [load, contract] = await fANTOM;

    const data = await contract.players(accounts);//
const structure =await contract.userInfo(accounts)
    // console.log(structure.structure,"await contract.getUserInfo(accounts);");
    const balace=structure.for_withdraw
    // const bonus=await contract.getUserReferralBonus(accounts);
    const Checkpoint=data.last_payout.toString()
    
    // console.log(balace,"balacebalacebalacebalace");
// console.log(data,"datadatadatadata");


    // returns(uint256 for_withdraw, uint256 total_invested, uint256 total_withdrawn, uint256 total_match_bonus, uint256[BONUS_LINES_COUNT] memory structure) {
    // const date = await contract.getDAte();
    // const dateNumber = date.toNumber();
    // const nextNumber = data.nextAssignment_.toNumber();
    // let interval = dateNumber > nextNumber ? 0 : nextNumber - dateNumber;
    // let time_ = interval / 3600;

    // console.log(interval, "date");

    

    const pausa = false; //await contract.isPaused();
    // let _referrerBonus = await contract.getReferrerBonus(accounts);
    // _referrerBonus = _referrerBonus.map((value) => Number(utils.formatEther(value)).toFixed(4));

    let referrerAmount =Number( utils.formatEther(data.total_match_bonus)).toFixed(4)
    let _referrerBonus = [0,0,0,0,0];

    // data.referrerCount_.map((value) => {
    //   referrerAmount += Number(value.toString());
    // });
    structure.structure.map((value,i) => {
      _referrerBonus[i] = value.toString();
    });
    // console.log(Checkpoint);

    console.log(balace,"_referrerBonus");
    const data_ = {
      totalWithdrawn_: pausa? 0:Number( utils.formatEther(data.total_withdrawn)).toFixed(4),
      totalDeposits_: Number(utils.formatEther(data.total_invested)).toFixed(4),
      totalBonus_: Number(utils.formatEther(data.match_bonus)).toFixed(4),
      // totalreinvest_: pausa?0:utils.formatEther(data.totalreinvest_),
      // hold_: pausa?0:data.hold_.toString(),
      balance_: pausa ? 0 : Number(utils.formatEther(balace)).toFixed(4),
      // nextAssignment_: pausa ? 0 : data.nextAssignment_.toString(),
      // amountOfDeposits: data.amountOfDeposits.toString(),
      checkpoint: pausa ? 0 :Number(Checkpoint),
      // isUser_: data.isUser_,
      referrer_: data.upline,
      referrerCount_:_referrerBonus,      
      referrerAmount: referrerAmount,
      // time_: time_.toFixed(2),
      // referrerBonus: utils.formatEther(_referrerBonus),
    };
    // console.log(data_,"getUserDatagetUserData");
    setuserData(data_);
  };

  const getPublicData = async () => {
    if (
      !isLoaded &&
      accounts != "000000000000000000000000000000000000000000000"
    )
      return;
    const [load, contract] = await fANTOM;

    const pausa = await contract.isPaused();

    const data = await contract.getPublicData();

    const data_ = {
      totalUsers_: data.totalUsers_.toString(),
      totalInvested_: utils.formatEther(data.totalInvested_.toString()),
      totalReinvested_: utils.formatEther(data.totalReinvested_.toString()),
      totalWithdrawn_: utils.formatEther(data.totalWithdrawn_.toString()),
      totalDeposits_: data.totalDeposits_.toString(),
      balance_: utils.formatEther(data.balance_.toString()).toString(),
      roiBase: data.roiBase.toString(),
      // bonusPool: data.bonusPool.toString(),
      // comunityBonus: data.comunityBonus.toString(),
      // currentRoi: Number(data.currentRoi.toString())/10,
      maxProfit: data.maxProfit.toString(),
      minDeposit: data.minDeposit.toString(),
      daysFormdeploy: data.daysFormdeploy.toString(),
    };

    setallData(data_);
  };

  const datas = {
    userData,
    allData,
    invest,
    withdraw,
    reinvestment,
    updateHandle,
    idHandle,
    id,
    solPrice,
    userPlans,
    balanceOf,
    isApprove,
    approveHandle,
    deposit,
    getUserDataDeposit,
  };

  return (
    <TonkenContext.Provider value={datas}>{children}</TonkenContext.Provider>
  );
};

export { TokenProvider };
export default TonkenContext;
